
<template>

    <div ref="LoadingPictureContainer" class="LoadingPictureContainer" :style="{left:Left,top:Top}"
         v-show="Visible==true">
         
        <img :src="UrlPrefix+'/static/Image/Loading.gif'" />
    </div>


</template>


<script scoped>
    import Utility from '@/Common/Utility'

    export default {

        data() {
            return {

                VirtualDirectory : "",
                UrlPrefix :"",
                Left: 0,
                Top: 0
            }
        }
        ,
        props: ["value", "Visible"],


        computed: {

        }
        ,

        methods: {
        },

        mounted() {
            setTimeout(
                () => {
                    document.body.insertAdjacentElement(
                        "BeforeEnd",
                        this.$refs.LoadingPictureContainer
                    );
                },
                100
            );
        },

        beforeMounted() {

        },

        created() {
            let browserHeight;

            browserHeight = Utility.GetBrowserHeight();

            this.Left = (document.body.clientWidth / 2 - 10) + "px";
            this.Top = ((Utility.GetScrollTop() + browserHeight / 2) - 1) + "px";


            if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {

                if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                    this.VirtualDirectory = "/" + AppSettings.VirtualDirectory;
                    this.UrlPrefix = this.VirtualDirectory + "/";
                }
                else {
                    this.VirtualDirectory = "";
                    this.UrlPrefix = "";
                }
            }
        },

        watch: {
            Visible: function (newVal, oldVal) {
                let browserHeight;

                browserHeight = Utility.GetBrowserHeight();
                this.Left = (document.body.clientWidth / 2 - 10) + "px";
                this.Top = ((Utility.GetScrollTop() + browserHeight / 2) - 1) + "px";

            }

        }
    }
</script>

<style>
    .LoadingPictureContainer {
        z-index: 10000;
        position: absolute;
        display: inline-block;
    }
</style>
